// Same north-facing arrow used by the default map's pointer.svg.
const POINTER_PATH = "M6.8,9.5l-5,3.1c-0.1,0-0.1,0-0.1-0.1L6.7,0.7c0,0,0.1,0,0.1,0l5.1,11.9c0,0.1,0,0.1-0.1,0.1L6.8,9.5z";

export function googleDirectionIcon(direction, size = 26) {
  const heading = Number(direction);
  return {
    path: POINTER_PATH,
    anchor: new google.maps.Point(6.75, 6.75),
    fillColor: "#386bff",
    fillOpacity: 1,
    strokeWeight: 0,
    scale: size / 13.5,
    rotation: Number.isFinite(heading) ? heading : 0,
  };
}
